// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 191) return "static/chunks/191.1a4ab9a257c44bd7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"765":"2a69f30bfddaa7cc","938":"b9777b9a6eb7eab3"}[chunkId] + ".js";
};